import { createGlobalStyle } from "styled-components";

export const TourGlobalStyles = createGlobalStyle`
  /* Popover container */
  .driver-popover {
    background: linear-gradient(135deg, #1a3a47 0%, #153A45 100%) !important;
    border-radius: 12px !important;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.1) !important;
    padding: 20px !important;
    max-width: 380px !important;
    border: none !important;
    color: #ffffff !important;
  }

  /* Title styling */
  .driver-popover-title {
    font-size: 18px !important;
    font-weight: 600 !important;
    color: #ffffff !important;
    margin-bottom: 8px !important;
    letter-spacing: -0.3px !important;
  }

  /* Description styling */
  .driver-popover-description {
    font-size: 14px !important;
    color: rgba(255, 255, 255, 0.75) !important;
    line-height: 1.6 !important;
    margin-bottom: 16px !important;
  }

  /* Progress indicator */
  .driver-popover-progress-text {
    font-size: 12px !important;
    color: rgba(255, 255, 255, 0.5) !important;
    font-weight: 500 !important;
  }

  /* Navigation buttons container */
  .driver-popover-navigation-btns {
    display: flex !important;
    gap: 8px !important;
    justify-content: flex-end !important;
  }

  /* Primary button (Next/Done) */
  .driver-popover-next-btn {
    background: linear-gradient(135deg, #FE6E5F 0%, #e55a4c 100%) !important;
    color: #ffffff !important;
    border: none !important;
    border-radius: 8px !important;
    padding: 8px 20px !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    cursor: pointer !important;
    transition: all 0.2s ease !important;
    box-shadow: 0 4px 12px rgba(254, 110, 95, 0.3) !important;
    letter-spacing: 0.3px !important;
    text-shadow: none !important;
  }

  .driver-popover-next-btn:hover {
    transform: translateY(-1px) !important;
    box-shadow: 0 6px 16px rgba(254, 110, 95, 0.4) !important;
  }

  /* Secondary button (Previous) */
  .driver-popover-prev-btn {
    background: rgba(255, 255, 255, 0.1) !important;
    color: #ffffff !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    border-radius: 8px !important;
    padding: 8px 16px !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    cursor: pointer !important;
    transition: all 0.2s ease !important;
    text-shadow: none !important;
  }

  .driver-popover-prev-btn:hover {
    background: rgba(255, 255, 255, 0.15) !important;
    border-color: rgba(255, 255, 255, 0.3) !important;
  }

  .driver-popover-prev-btn.driver-popover-btn-disabled {
    opacity: 0.5 !important;
    cursor: not-allowed !important;
  }

  /* Overlay */
  .driver-overlay {
    background-color: rgba(0, 0, 0, 0.6) !important;
  }

  /* Highlighted element */
  .driver-highlighted-element {
    border-radius: 12px !important;
  }

  /* Arrow */
  .driver-popover-arrow {
    border: 8px solid transparent !important;
  }

  .driver-popover-arrow-side-left {
    border-left-color: #153A45 !important;
  }

  .driver-popover-arrow-side-right {
    border-right-color: #153A45 !important;
  }

  .driver-popover-arrow-side-top {
    border-top-color: #1a3a47 !important;
  }

  .driver-popover-arrow-side-bottom {
    border-bottom-color: #153A45 !important;
  }

  /* Footer with progress */
  .driver-popover-footer {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    margin-top: 12px !important;
    padding-top: 12px !important;
    border-top: 1px solid rgba(255, 255, 255, 0.1) !important;
  }

  /* Close button (X) */
  .driver-popover-close-btn {
    position: absolute !important;
    top: 12px !important;
    right: 12px !important;
    background: rgba(255, 255, 255, 0.1) !important;
    box-shadow: none !important;
    padding: 4px !important;
    border-radius: 50% !important;
    width: 24px !important;
    height: 24px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: 14px !important;
    color: rgba(255, 255, 255, 0.7) !important;
    border: none !important;
    cursor: pointer !important;
  }

  .driver-popover-close-btn:hover {
    background: rgba(255, 255, 255, 0.2) !important;
    color: #ffffff !important;
  }
`;
